/**
 * Away from the keyboard (ADR 0080): read by the server from the intents it
 * receives, never claimed by the client. Five quiet minutes, or `/absent`,
 * and the plate, the friends, the guild and the party read « Absent »; the
 * next intent that is the player's own brings them back.
 */
export const AWAY_AFTER_MS = 5 * 60_000;
/**
 * Messages a client sends on its own (a panel refreshing what it shows) or
 * that ask to be away: none of them proves someone is at the keyboard.
 */
const PASSIVE_MESSAGES = new Set([
    'set_away',
    'quests',
    'contracts',
    'achievements',
    'profile',
    'aerie_status',
]);
/** Whether this intent proves the player is at the keyboard. */
export function countsAsActivity(type) {
    return !PASSIVE_MESSAGES.has(type);
}
export function isAway(clock, now) {
    return clock.byChoice || now - clock.lastActiveAt >= AWAY_AFTER_MS;
}
//# sourceMappingURL=away.js.map